import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { EventMessage, AuthenticationResult, EventType } from '@azure/msal-browser';
import { LoadingService } from './shared/services/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false
})
export class AppComponent {
  userAccount: any = null;

  constructor(
    private msalService: MsalService,
    private router: Router,
    public loadingService: LoadingService
  ) { }

  async ngOnInit() {
    this.msalService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.HANDLE_REDIRECT_START) {
        this.loadingService.show();
      }

      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const authResult = event.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(authResult.account);
        this.userAccount = authResult.account;

        this.router.navigate(['/']);
      }
    });

    // Ensure MSAL is initialized before using it
    await this.msalService.instance.initialize();

    // Set active account if already logged in
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.msalService.instance.setActiveAccount(accounts[0]);
      this.userAccount = accounts[0];
    }

    // Process redirect response (returns null if not a redirect)
    await this.msalService.instance.handleRedirectPromise().then((result: AuthenticationResult | null) => {
      if (result) {
        this.msalService.instance.setActiveAccount(result.account);
      } else {
        // Attempt silent login if no redirect result
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
        }
      }
    });
  }
}
